// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ifvo","largestCol":"styles_largestCol__4nfGX","smallestCol":"styles_smallestCol__226kV"};